import React, { MouseEvent } from "react";
import styled from "styled-components";
import { ReactComponent as TransactionIcon } from "../icons/flip-vertical.svg";
import { ReactComponent as CopyIcon } from "../icons/copy-2.svg";
import { ReactComponent as SettingsIcon } from "../icons/setup-preferences.svg";
import { ReactComponent as ReplayIcon } from "../icons/cycle.svg";
import { ReactComponent as FavIcon } from "../icons/fav.svg";

const StyledIconButton = styled.button`
  border-style: none;
  cursor: pointer;
  user-select: none;
  background: none;
  color: white;

  span {
    margin-left: 0.5rem;
    font-size: 0.9rem;
  }

  &:hover {
    opacity: 0.6;
  }

  svg {
    &.size-s {
      width: 14px;
      height: 14px;
    }
    &.size-m {
      width: 18px;
      height: 18px;
    }
    &.size-l {
      width: 24px;
      height: 24px;
    }
  }
`;

interface Props {
  icon: "transaction" | "copy" | "settings" | "replay" | "favorite";
  size: "s" | "m" | "l";
  onClick: (event: MouseEvent<any>) => void;
  text?: string;
}

const iconMap = {
  transaction: TransactionIcon,
  copy: CopyIcon,
  settings: SettingsIcon,
  replay: ReplayIcon,
  favorite: FavIcon,
};

const IconButton: React.FC<Props> = ({ icon, size, onClick, text }) => {
  const Icon = iconMap[icon];

  return (
    <StyledIconButton onClick={onClick}>
      <Icon className={`size-${size}`} />
      {text && <span>{text}</span>}
    </StyledIconButton>
  );
};

export default IconButton;
